<template>
	<el-table :data="tableData" style="width: 100%">
		<el-table-column type="expand">
			<template slot-scope="props">
				<el-form label-position="left" inline class="demo-table-expand">
					<div v-for="(value, key, index) in props.row" :key="index">
						<el-form-item style="width: 100%;" label-width="150px" v-if="hasName(key)!=='null'"
							:label="hasName(key)">
							<img v-if="hasImage(value)" :src="value"
								style="width: 100%;height: 200px;object-fit: contain;" alt="">
							<span v-else>{{ value }}</span>
						</el-form-item>
					</div>
					<el-form-item>
						<el-button v-if="props.row.status == '已报名'" @click="handleClick(props.row)" size="small">取消报名
						</el-button>
						<el-button type="primary" v-if="props.row.status == '已报名'" @click="openApply(props.row)" size="small">回执表
						</el-button>
					</el-form-item>
				</el-form>
			</template>
		</el-table-column>
		<el-table-column label="姓名" prop="real_name">
		</el-table-column>
		<el-table-column label="单位" prop="company_name">
		</el-table-column>
		<el-table-column label="手机号" prop="cellphone">
		</el-table-column>
	</el-table>
</template>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>

<script>
	import {
		getRuleCancle,
		getNoVipCancle
	} from '@/api/moudles/activities.js'
	import {
		API_DOMAIN
	} from "@/api/api.js"
	export default {
		props: {
			tableData: {
				type: Array,
				default: () => []
			},
			nameTable: {
				type: Array,
				default: () => []
			},
			rule_code: {
				type: [Number, String],
				default: ''
			}
		},
		computed: {
			hasImage() {
				return (value) => {
					if (value && typeof value == 'string') {
						if (value.indexOf('http') != -1) {
							return true
						}
					}
					return false
				}
			}
		},
		methods: {
			// 打开回执表
			openApply(row) {
				window.open(`${API_DOMAIN}/adminapi/member/view-receipt?id=${row.id}&meeting_code=${row.meeting_code}`)
			},
			hasName(key) {
				for (let index in this.nameTable) {
					if (this.nameTable[index].prop == key) {
						return this.nameTable[index].label
					}
				}
				return 'null'
			},
			handleClick(row) {
				this.$confirm('此操作将取消该会议报名, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (this.$store.state.user.userVip === true) {
						getRuleCancle({
							data: {
								code: row.code,
								rule_code: this.rule_code
							},
							success: res => {
								console.log('会员取消', res)
								this.$message({
									type: 'success',
									message: res.msg
								});
								this.$emit('refresh')
							}
						})
					} else {
						getNoVipCancle({
							data: {
								code: row.code,
								rule_code: this.rule_code
							},
							success: res => {
								console.log('非会员取消', res)
								this.$message({
									type: 'success',
									message: res.msg
								});
								this.$emit('refresh')
							}
						})
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
		}
	}
</script>